export const BASE_URL = "https://codigolactancia.org.mx/api";
export const TRAINING_URL = `${BASE_URL}/training`;
